// vendors
import { createFeatureSelector, createSelector } from '@ngrx/store';

// local application
import { IDialogInitialState } from './dialog.state';

export const selectDialogFeatureState =
  createFeatureSelector<IDialogInitialState>('dialog');

// select 'isOpening' on our state
export const selectIsDialogOpening = createSelector(
  selectDialogFeatureState,
  (state: IDialogInitialState) => state.isOpening
);
